import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "@/shared/components/layout/dashboard-layout/page-header.tsx";
import { Skeleton } from "@/ui/components/ui/skeleton";
import { useGetMachineSettings } from "@/settings/api";
import MachineSettingsFormHandler from "@/machines/components/settings/machine-settings-form-handler";

const MachineSettings = () => {
  const { t } = useTranslation("settings");
  const { id } = useParams<{ id: string }>();
  const { data: settingsData, isLoading } = useGetMachineSettings(
    id ? parseInt(id) : undefined
  );

  const machine = settingsData?.data.data.machines?.[0];
  const organization = settingsData?.data.data.organization;

  const breadcrumbs = [
    {
      path: "/",
      breadcrumb: organization?.name || t("breadcrumbs.organization"),
    },
    {
      path: "/settings/machine",
      breadcrumb: t("breadcrumbs.machineSettings"),
    },
  ];

  if (!id) {
    return (
      <div className="h-full">
        <PageHeader breadcrumbs={breadcrumbs} />
        <div className="p-6">
          <p className="text-muted-foreground">{t("machine.selectPrompt")}</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="h-full">
        <PageHeader breadcrumbs={breadcrumbs} />
        <div className="p-6 space-y-6 max-w-4xl">
          <Skeleton className="h-16 w-full" />
          <Skeleton className="h-64 w-full" />
        </div>
      </div>
    );
  }

  if (!machine) {
    return (
      <div className="h-full">
        <PageHeader breadcrumbs={breadcrumbs} />
        <div className="p-6">
          <p className="text-muted-foreground">{t("machine.notFound")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <PageHeader breadcrumbs={breadcrumbs} />
      <div className="p-6 space-y-6 max-w-4xl">
        <div>
          <h1 className="text-2xl font-bold">{t("machine.title", { name: machine.name })}</h1>
          <p className="text-muted-foreground">
            {t("machine.description", { name: machine.name })}
          </p>
        </div>

        <MachineSettingsFormHandler machine={machine} />
      </div>
    </div>
  );
};

export default MachineSettings;
